import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <>
      <section className="footerContact">
        <div className="container">
          <div className="send flex">
            <div className="text">
              <h1>Whatsapp: 075 351 85 86  </h1>
         
            </div>
            <div className="text">
              <h1>Email : gayankanchana55@gmail.com</h1>
           
            </div>
          </div>
        </div>
      </section>
      
      <footer>

        <div className="legal">
          <p>&copy; 2024 Gaya walker. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
